
define('ldsh!modules/lp_info/templates/variant_list', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<h3 class="ed-h-gamma">' +
((__t = ( title )) == null ? '' : __t) +
'</h3>\n<table class="ed-table ed-table-striped">\n  <thead>\n    <tr>\n      <th class="ed-table-type-th"></th>\n      <th data-i18n="landingPage.name" data-field="nombre" class="ed-table-name-th sortable">Nombre</th>\n      <th class="ed-table-weight-th sortable"  data-i18n="landingPage.weight" data-field="peso">Peso</th>\n      <th class="ed-table-visits-th sortable" data-i18n="landingPage.visits" data-field="visitas">Impresiones</th>\n      <th class="ed-table-visitors-th sortable"  data-i18n="landingPage.visitors" data-field="visitantes">Visitas</th>\n      <th data-i18n="landingPage.convert" data-field="conversion" class="ed-table-conversions-th sortable">Conversiones</th>\n      <th data-i18n="landingPage.crtShort" data-field="ctr" class="ed-table-ctr-th sortable">CRT</th>\n      <th class="ed-table-actions-th"></th>\n    </tr>\n  </thead>\n  <tbody class="js-item-container">\n  </tbody>\n</table>\n\n';
 if (isMain && AMPDetected) { ;
__p += '\n<section class="amp__rendering__configuration">\n  <input\n    type="checkbox"\n    name="amp_rendering"\n    id="redirectToAMP"\n    class="js-redirect-to-amp"\n    value="' +
((__t = ( redirectToAMPConfig )) == null ? '' : __t) +
'" ' +
((__t = ( !enableAMPConfig ? 'disabled readonly checked="checked"' : '' )) == null ? '' : __t) +
'\n    ' +
((__t = ( currentRedirectAMPConfig == 'mobile' ? 'checked="checked"' : '' )) == null ? '' : __t) +
' /><label\n        for="redirectToAMP">' +
((__t = ( redirectAMPNotice )) == null ? '' : __t) +
'</label><i\n        class="inline-spinner-load"\n        style="display: none" />\n</section>\n';
 } ;
__p += '\n';

}
return __p
};});

